import { defineAction, number, object, string } from '~/prix'
import agentPolygonInsightAction from './agentPolygonInsight.action.json'

const agentPolygonInsightDefinition = defineAction({
  ...agentPolygonInsightAction,
  input: object({
    agentCpf: string(),
  }),
  output: object({}),
})

export default agentPolygonInsightDefinition
